import { StateType } from '@redux/reducers';

export const appStateSelector = ({ appState }: StateType) => appState;
